import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import constants from 'Constants';
import { deserializeTimestamp, deserializeWithMappers, setFieldValues } from 'stores/Utils';


class MemberStore {

  @setter @observable id;
  @setter @observable externalId;
  @setter @observable contactId;
  @setter @observable contactEmail;
  @setter @observable currentPoints;
  @setter @toggle @observable isEnrolled;
  @setter @observable dob;
  @setter @observable completedActivityRuleIds;

  static create(data={}) {
    const instance = new MemberStore();
    setFieldValues(instance, data);
    return instance;
  }

  static getDefaults() {
    return {
      "id": null,
      "externalId": null,
      "contactId": null,
      "contactEmail": "",
      "currentPoints": "",
      "isEnrolled": false,
      "dob": null,
      "completedActivityRuleIds": [],
    };
  }

  constructor(defaults=MemberStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  @action reset(defaults=MemberStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  getDeserializeMappers() {
    return [
      {"field": "id"},
      {"field": "externalId", "accessor": "external_id"},
      {"field": "contactId", "accessor": "contact_id"},
      {"field": "contactEmail", "accessor": "contact_email"},
      {"field": "currentPoints", "accessor": "current_points"},
      {"field": "isEnrolled", "accessor": "is_enrolled"},
      {"field": "dob", "accessor": "dob", "type": constants.DESERIALIZE_TYPE_CUSTOM, "extract": deserializeTimestamp},
      {"field": "completedActivityRuleIds", "accessor": "completed_activity_rule_ids"},
    ];
  }

  @action async deserialize(data) {
    await deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }

  getData() {
    let data = {};
    data['id'] = this.id;
    data['external_id'] = this.externalId;
    data['contact_id'] = this.contactId;
    data['contact_email'] = this.contactEmail;
    data['current_points'] = this.currentPoints;
    data['dob'] = this.dob;
    return data;
  }

  @action addCompletedActivityRuleIds(id) {
    if (this.completedActivityRuleIds.includes(id)) return
      this.completedActivityRuleIds.push(id);
  }
}

export default MemberStore;


